export default [
  {
    path: '/daka/poster',
    name: 'dakaposter',
    component: () => import('@/views/record/dakaposter.vue')
  }
]
